import { render } from "./ContentElement.vue?vue&type=template&id=3aab8ec0"
import script from "./ContentElement.vue?vue&type=script&lang=js"
export * from "./ContentElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__